<template>
  <div>
    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-secondary">Reference:</h5>

              <p class="card-text text-info">{{ request.requestId }}</p>
            </div>
          </div>

          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-muted">Agent Name:</h5>
              <p class="card-text text-info">{{ request.user }}</p>
            </div>
          </div>

          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-secondary">Amount:</h5>

              <p class="card-text text-info">
                {{ `₦${format.format(request.amount.toFixed(4))}` }}
              </p>
            </div>
          </div>

          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row w-20">
              <h5 class="card-title col-md-4 text-secondary">WalletID:</h5>

              <p class="card-text text-info">{{ request.walletId }}</p>
            </div>
          </div>
          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-secondary">Type:</h5>

              <p class="card-text text-info">{{ request.type }}</p>
            </div>
          </div>
          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-secondary">Comment:</h5>

              <p class="card-text text-info">{{ request.description }}</p>
            </div>
          </div>

          <div
            class="card"
            style="width: 95em"
            v-if="request.status !== 'pending'"
          >
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-secondary">
                Approved / Rejected By:
              </h5>

              <p class="card-text text-info">{{ request.approvedBy }}</p>
            </div>
          </div>

          <div class="card" style="width: 95em">
            <div class="card-body text-secondary row">
              <h5 class="card-title col-md-4 text-secondary">Status:</h5>

              <p class="card-text text-info">{{ request.status }}</p>
            </div>
          </div>
          <div
            class="card-body row"
            v-if="
              request.status === 'pending' &&
              auth.user._id === request.creatorId
            "
          >
            <p-button type="info" round @click.native.prevent="cancel">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Cancel Request
            </p-button>
            <span class="ml-5"></span>
            <p-button type="danger" round @click.native.prevent="close">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Close Request
            </p-button>
          </div>

          <div
            class="card-body row"
            v-if="
              request.status === 'pending' &&
              auth.user._id !== request.creatorId
            "
          >
            <p-button type="danger" round @click.native.prevent="reject">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Reject Request
            </p-button>
            <span class="ml-5"></span>
            <p-button type="info" round @click.native.prevent="approve">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Approve Request
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
export default {
  data() {
    return {
      request: {},
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions(["updateAgent", "setNotification"]),
    reject() {
      this.$confirm("Reject Fund Request?").then(async () => {
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/initiate/action/reject/${this.$route.params.requestId}`,
          );
          const { message } = res.data;
          this.setNotification({
            type: "success",
            message,
          });
          await this.getFundRequest();
          return this.$router.push({ name: "Wallet Funding" });
          // }
        } catch (err) {
          const data = err.response
            ? err.response.data
            : { message: err.toString() };
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Perform Action",
          });
        }
      });
    },
    approve() {
      this.$confirm(
        `Accept Fund Request? This will ${this.request.type} Users Wallet!!!`,
      ).then(async () => {
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/initiate/action/approve/${this.$route.params.requestId}`,
          );
          const { message } = res.data;
          this.setNotification({
            type: "success",
            message,
          });
          await this.getFundRequest();
          return this.$router.push({ name: "Wallet Funding" });
          // }
        } catch (err) {
          const data = err.response
            ? err.response.data
            : { message: err.toString() };
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Perform Action",
          });
        }
      });
    },
    cancel() {
      this.$confirm("Are you sure you want to cancel this Request?").then(
        async () => {
          try {
            // else {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/initiate/action/cancel/${this.$route.params.requestId}`,
            );
            const { message } = res.data;
            this.setNotification({
              type: "success",
              message,
            });
            await this.getFundRequest();
            return this.$router.push({ name: "Wallet Funding" });
            // }
          } catch (err) {
            const data = err.response
              ? err.response.data
              : { message: err.toString() };
            this.setNotification({
              type: "danger",
              message: data.message || "Unable to Perform Action",
            });
          }
        },
      );
    },
    close() {
      return this.$router.push({ name: "Wallet Funding" });
    },
    async getFundRequest() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/initiate/get-requests/${this.$route.params.requestId}`,
        );
        const { request } = res.data;
        this.request = request;
      } catch (err) {
        const { data } = err.response.data;
        console.log(data);
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch Request Data",
          });
        }
      }
    },
  },
  async mounted() {
    await this.getFundRequest();
  },
};
</script>
<style></style>
